import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Progress } from "@/config/antd";
import { CloseOutlined, PlusOutlined } from "@/config/antd";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import TextEditor from "@/components/common/inputs/Text_Editor";

const BulkInviteModal = ({ isVisible, onClose }) => {
  const [personalNote, setPersonalNote] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [editorContent, setEditorContent] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setFileLoading(true);
      // Simulate file loading
      setTimeout(() => {
        setFileLoading(false);
      }, 2000);
    }
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      closeIcon={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}>
      <div className="flex flex-col bg-white">
        {/* Header */}
        <div className="p-4 px-6 flex justify-between items-center">
          <h2 className="heading-regular text-primary">
            Invite Members in Bulk
          </h2>
          <CloseOutlined
            onClick={onClose}
            className="cursor-pointer"
            style={{
              color: "var(--veegil-color-primary)",
              backgroundColor: "var(--veegil-color-lighter-blue)",
              borderRadius: "50%",
              padding: "4px",
            }}
          />
        </div>

        {/* Content Area */}
        <div className="flex flex-col px-10 pb-10 space-y-6">
          {/* Upload CSV Section */}
          <label className="border-2 border-dashed border-primary rounded-lg p-8 bg-secondary cursor-pointer">
            <input
              type="file"
              className="hidden"
              accept=".csv"
              onChange={handleFileChange}
            />
            <div className="flex flex-col items-center justify-center text-center">
              {!fileName ? (
                <>
                  <WebIcon icon="ContentEdit2" className="mb-4 w-12 h-12" />
                  <h3 className="text-small text-gray-500 font-bold mb-2">
                    UPLOAD CSV FILE
                  </h3>
                  <p className="text-small text-gray-500">
                    Quickly bulk invite your colleagues by uploading an excel
                    CSV file here
                  </p>
                </>
              ) : (
                <>
                  <WebIcon icon="ContentEdit2" className="mb-4 w-12 h-12" />
                  <p className="text-small text-gray-500 mb-2">{fileName}</p>
                  {fileLoading && (
                    <div className="w-full">
                      <Progress
                        percent={50}
                        showInfo={false}
                        strokeColor="var(--veegil-color-primary)"
                        strokeWidth={4}
                        className="w-full"
                      />
                      <p className="text-small text-primary mt-2">
                        File loading
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
          </label>

          {/* Personal Note Section */}

          {personalNote && (
            <TextEditor
              label="LONG NOTE"
              placeholder="Write your personal note here..."
              className="h-[139px] w-[350px]"
              value={editorContent}
              onChange={setEditorContent}
            />
          )}
          <div className="flex flex-col items-center">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => setPersonalNote(!personalNote)}>
              <span className="text-regular font-bold text-lighterGrey">
                {personalNote
                  ? "Remove Personal note to the invitation"
                  : "Add a personal note to the invitation"}
              </span>
              <div className="bg-primary rounded-full w-7 h-7 flex items-center justify-center">
                <PlusOutlined className="text-white" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="w-full bg-secondary p-4">
          <Button
            text="SEND INVITES"
            color="primary"
            className="w-full"
            customBgColor="primary"
            customTextColor="white"
          />
        </div>
      </div>
    </Modal>
  );
};

BulkInviteModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BulkInviteModal;
